export enum PermissionType {
  Organization = 'Organization',
  Api = 'Api',
}
